module.exports = __webpack_public_path__ + "static/media/desert3.0b9fd577.png";